export default {
    yourItems: "Vos objets",
    useItem: "Utiliser",
    useItemSuccess: "Utilisation de l'objet réussie",

    itemNotExists: "Vous ne possédez plus cet objet",
    itemAlreadyActive: "L'effet de cet objet est encore actif. Réessayez plus tard, s'il vous plait",
    itemNoBuddy: "Ce dresseur n'a pas de compagnon",
    itemTeamListFull: "The maximum of teams you can have is 20",

    PokemonFullHp: "Ce Pokémon a ses pv au maximum",
    PokemonDead: "Ce Pokémon a besoin d'être réanimé",
    PokemonStillAlive: "Ce Pokémon n'a pas besoin d'être réanimé",
    PokemonNoStatusCondition: "Ce Pokémon n'est pas affecté par un statut",
    PokemonFullPP: "Tous les PP des capacités sont restaurés",

    sellConfirmMessage: (name) => `Are you sure that you want to sell your <span class="font-weight-bold">${name}</span>?`,
    useConfirmMessage: (item, pkm) => `Are you sure that you want to use the item <span class="font-weight-bold">${item}</span> on <span class="font-weight-bold">${pkm}</span>?`,
    sellSuccess: "You successfully sold your item",

    wonderPassNoCooldown: "Your Wonderpass is not on cooldown!",
    pokedailyNoCooldown: "Your Pokedaily is not on cooldown!"
};